// extracted by mini-css-extract-plugin
export default {"custom-pagination-button":"styles_custom-pagination-button__ZI+YL"};